export enum EUserColor {
  Initial = 'initial',
  Dark = 'dark',
  Purple = 'purple',
  Plum = 'plum',
}
